import { styled } from "@mui/system";
import { Grid } from "@mui/material";
import { ArrayRemoveButton } from "../../../Buttons/ArrayRemoveButton";

export const FlexContainer = styled(Grid)(({ theme }) => ({
  marginTop: "0",
  marginBottom: "0",
  padding: "0 10px"
}));

export const RelativeContainer = styled("div")(({ theme }) => ({
  position: "relative"
}));

export const TabletContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    marginBottom: "20px"
  }
}));

export const ButtonWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
}));

export const RemoveButton = styled(ArrayRemoveButton)(({ theme }) => ({
  position: "relative",
  right: "auto",
  left: "auto",
  top: "auto",
  float: "right",
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
}));

export const AddButton = styled("div")(({ theme }) => ({
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
}));

export const MarginTop15 = styled(Grid)(({ theme }) => ({
  marginTop: 15
}));
